<template>
  <div class="bg-white rounded shadow  container-box">
    <div class="row">
      <div class="col-md-12">
        <router-view/>
      </div>
    </div>
    <dashboard-menu v-if="isClient"></dashboard-menu>
  </div>


</template>

<script>
  import {mapGetters} from 'vuex';
  import DashboardMenu from './DashboardMenu';

  export default {
    name: 'DefaultLayout',

    components: {
      DashboardMenu
    },
    computed: {
      ...mapGetters('auth', [
        'isClient'
      ]),
    },
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/DefaultDashboardLayout.vue